import {Box, Text} from '@mantine/core';
import type React from 'react';
import {MdClose} from 'react-icons/md';
import {MYPAGE_SCOUT_SETTING} from '../../../config/constants/routes';
import {useMediaQuery} from '../../../shared/services/useMediaQuery';

type Props = {
  closePopup: () => void;
  userName?: string;
};

export const ScoutPromo: React.FC<Props> = ({closePopup, userName}) => {
  const handlePressButton = () => {
    location.href = MYPAGE_SCOUT_SETTING;
  };

  const {isPC} = useMediaQuery();
  return (
    <>
      {isPC ? (
        <Box className="flex flex-row justify-between items-center">
          <Box className="flex flex-row text-base text-black">
            {userName}
            さんは、Premiumスカウト未登録です。優良企業に見つけてもらうために、まずは登録しましょう！
          </Box>
          <Box className="flex flex-row items-center gap-12">
            <Box
              className="cursor-pointer flex items-center justify-center border-primary border-[1px] bg-white rounded-[8px] py-8 px-12"
              onClick={handlePressButton}
            >
              <Text className="text-sm text-primary font-bold">
                登録はこちら
              </Text>
            </Box>
            <Box
              className="w-24 h-24 flex items-center justify-center rounded-full bg-black-3 cursor-pointer"
              onClick={closePopup}
            >
              <MdClose size={24} color="white" />
            </Box>
          </Box>
        </Box>
      ) : (
        <Box
          className="flex flex-row justify-between text-sm"
          onClick={handlePressButton}
        >
          <Text>
            {userName}
            さんは、Premiumスカウト未登録です。優良企業に見つけてもらうために、まずは登録しましょう！
          </Text>
          <Box
            className="flex flex-row text-primary-1 items-center"
            onClick={(e) => {
              e.stopPropagation();
              closePopup();
            }}
          >
            <MdClose size={16} className="text-black-3" />
          </Box>
        </Box>
      )}
    </>
  );
};
